import { render, staticRenderFns } from "./getCode.vue?vue&type=template&id=df07ccf4&scoped=true&"
import script from "./getCode.vue?vue&type=script&lang=js&"
export * from "./getCode.vue?vue&type=script&lang=js&"
import style0 from "./getCode.vue?vue&type=style&index=0&id=df07ccf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df07ccf4",
  null
  
)

export default component.exports